import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import qs from "qs";

import { gameTypes, userTypes } from "domain/GamesSearch/types";
import {
    createOrders,
    subscribe,
    transferToReserve,
    unsubscribe,
} from "domain/Game/api";
import AnimatedModal from "components/Modal/AnimatedModal";
import { DateTime as Luxon, Interval } from "luxon";
import { Link } from "react-router-dom";
import Button from "ui/Button";
import Icon from "components/Icon";
import Alert from "components/Alert";
import { hideWebToAppBanner, showWebToAppBanner } from "lib/banner";
import { gameTypeTypes } from "domain/Directories/types";
import MobileAppsLinks from "components/MobileAppsLinks";
import ConfirmModal from "./ConfirmModal";
import { getHour } from "domain/Directories/selectors";
import { toast } from "react-toastify";
export const PAGE_AFTER_FILL_PROFILE = "PAGE_AFTER_FILL_PROFILE";

const SignUp = ({
    isLoggedIn,
    inProgress,
    is_participate,
    is_public,
    updateGameData,
    starts_at,
    organizer,
    id,
    userId,
    trackPlayerJoin,
    trackPlayerLeft,
    dropCard,
    private_code,
    gameLink,
    is_training,
    trainer,
    gameType,
    players,
    max_players,
    genderDoesNotMatch,
    unsubscribe_hours,
    age_limit,
    userAge,
    is_past,
    paymentMethod,
    isPaySuccess,
    payStatus,
    cost,
    is_available_for_pay,
}) => {
    if (!private_code) {
        private_code = qs.parse(location.search, { ignoreQueryPrefix: true })
            .code;
    }

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSubscribeOk, setShowSubscribeOk] = useState(false);
    const [showSubscribeReserve, setShowSubscribeReserve] = useState(false);
    const [showUnsubscribe, setShowUnsubscribe] = useState(false);
    const [showCantUnsubscribe, setShowCantUnsubscribe] = useState(false);
    const [error, setError] = useState(null);
    const [unsubscribeMessage, setUnsubscribeMessage] = useState(null);

    const gameForAdult = age_limit;
    const hasUserAge = typeof userAge === "number";
    const isOrganizer = organizer.id === userId;
    const isFreeGame = cost == 0;

    const disabledDueToAgeLimit =
        gameForAdult &&
        hasUserAge &&
        userAge < 18 &&
        !is_participate &&
        !isOrganizer;

    const playerFromReserve = players?.find((player) => player.id == userId)
        ?.from_reserve;
    const isPlayerInReserve = players?.find((player) => player.id == userId)
        ?.is_reserve;
    const isPlayerTransferByOrg = players?.find((player) => player.id == userId)
        ?.transfer_from_organizer;

    const toggleLogin = () => {
        window.localStorage.setItem(PAGE_AFTER_FILL_PROFILE, gameLink);
    };

    const toggleSubscribeOk = () => setShowSubscribeOk((show) => !show);

    const toggleSubscribeReserve = () =>
        setShowSubscribeReserve((show) => !show);

    const toggleUnsubscribe = () => setShowUnsubscribe((show) => !show);
    const onCloseUnsubscribeModal = () => {
        toggleUnsubscribe();
        if (document.location.pathname.indexOf("games/my") !== -1) {
            dropCard(id);
        }
    };

    const toggleCantUnsubscribe = () => setShowCantUnsubscribe((show) => !show);

    const onSubscribe = async (e, from_reserve) => {
        e?.preventDefault();
        e?.stopPropagation();

        try {
            const gameForAdult = age_limit;

            const shouldShowConfirmModal =
                !hasUserAge &&
                gameForAdult &&
                !showConfirmModal &&
                !is_participate;

            if (shouldShowConfirmModal) {
                return setShowConfirmModal(true);
            }

            const response = await subscribe(id, private_code, from_reserve);

            trackPlayerJoin(userId, id);

            showWebToAppBanner();

            const me = response.game.players.find(
                (player) => player.id === userId
            );

            if (me.reserve_order === 0) {
                if (
                    response.game?.payment_method === "online" &&
                    !isOrganizer &&
                    !isFreeGame
                ) {
                    createPayment();
                }
                setShowSubscribeOk(true);
            } else {
                setShowSubscribeReserve(true);
            }

            updateGameData(id, response.game);
        } catch (e) {
            setError(e.message);
            if (e?.data?.payload?.game) {
                updateGameData(id, e?.data?.payload?.game);
            }
        }
    };

    const onUnsubscribe = async () => {
        try {
            const response = await unsubscribe(id, private_code);

            trackPlayerLeft(userId, id);
            setShowUnsubscribe(true);

            updateGameData(id, response.game);
        } catch (err) {
            const { message } = err;
            const type = err.data.payload?.type;
            if (type && type === "cant_unsubscribe") {
                setUnsubscribeMessage(message);
                toggleCantUnsubscribe();
            }
        }
    };

    const createPayment = async () => {
        try {
            const res = await createOrders(
                id,
                `${window.location.href}?payId=${id}`
            );

            if (res?.confirmation_url) {
                window.location.href = res.confirmation_url;
            }
        } catch (err) {
            toast.error(`Ошибка: ${err.message}`);
        }
    };

    const transferPlayerToReserve = async () => {
        try {
            const res = await transferToReserve(id, userId);
            updateGameData(id, res.game);
        } catch (err) {
            throw Error;
        }
    };

    useEffect(() => {
        if (
            paymentMethod === "online" &&
            is_participate &&
            !isPlayerInReserve &&
            !isPaySuccess &&
            payStatus &&
            !isOrganizer &&
            !isPlayerTransferByOrg &&
            !isFreeGame
        ) {
            if (playerFromReserve) {
                transferPlayerToReserve();
            } else {
                onUnsubscribe();
            }
        }
    }, []);

    let buttonText = "Записаться";
    if (is_participate) {
        buttonText = "Отписаться";
    }

    if (inProgress) {
        buttonText = `${is_training ? `Тренировка` : `Игра`} началась`;
    }

    const startDT = Luxon.fromSQL(starts_at);
    const playerInReserve = players.find(
        (elem) => elem.id == userId && elem?.is_reserve
    );
    const mainListPlayers = players.filter((elem) => !elem?.is_reserve);
    const isFreePlaceInMainList = mainListPlayers.length < max_players;
    const disabledSignUpForGender =
        genderDoesNotMatch && buttonText === "Записаться";
    const cantUnsubscribe =
        Luxon.now() < Luxon.fromSQL(starts_at) &&
        Interval.fromDateTimes(Luxon.now(), Luxon.fromSQL(starts_at))?.length(
            "hours",
            true
        );
    const blockUnsubscribe =
        cantUnsubscribe < unsubscribe_hours && buttonText === "Отписаться";
    const canUnsubscribeBefore = Luxon.fromSQL(starts_at)
        ?.minus({ hours: unsubscribe_hours })
        ?.toFormat(" HH:mm,  dd.LL");
    const isHoldPay = !is_available_for_pay && paymentMethod === "online";
    const dateHoldPayOpen = Luxon.fromSQL(starts_at)
        ?.minus({ days: 6 })
        ?.toFormat("dd.LL");

    if (isHoldPay) {
        buttonText = `Запись откроется c ${dateHoldPayOpen}`;
    }

    const isDisabled =
        (!is_public && !private_code) ||
        inProgress ||
        disabledSignUpForGender ||
        blockUnsubscribe ||
        disabledDueToAgeLimit ||
        isHoldPay;

    const isShowPayButton =
        paymentMethod === "all" &&
        is_participate &&
        !isOrganizer &&
        !playerInReserve &&
        !isFreeGame &&
        (!isPaySuccess || !payStatus);

    const isTransferFromReserve =
        paymentMethod === "online" && isPlayerTransferByOrg;

    return (
        <>
            {isLoggedIn ? (
                <>
                    <Button
                        secondary={is_participate}
                        primary={!is_participate}
                        size="small"
                        shadowDesktopDown
                        fullWidth
                        onClick={is_participate ? onUnsubscribe : onSubscribe}
                        disabled={isDisabled}
                        mixes={[`shadow-medium-desktop-down`]}
                    >
                        <span className="btn__span">{buttonText}</span>
                    </Button>

                    {(isShowPayButton || isTransferFromReserve) &&
                        (is_available_for_pay ? (
                            <Button
                                primary
                                size="small"
                                shadowDesktopDown
                                fullWidth
                                onClick={createPayment}
                                mixes={[`shadow-medium-desktop-down`]}
                            >
                                <span className="btn__span">Оплатить</span>
                            </Button>
                        ) : (
                            <p className="c-gs-disabled">
                                Оплатить онлайн можно будет с {dateHoldPayOpen}
                            </p>
                        ))}

                    {!is_past && blockUnsubscribe && (
                        <p className="c-gs-disabled">
                            {`Организатор ограничил возможность отписаться от игры за ${unsubscribe_hours} ${getHour(
                                unsubscribe_hours
                            )} до её начала. Если у вас изменились планы - свяжитесь с организатором`}
                        </p>
                    )}
                </>
            ) : (
                <Link
                    to="/signin"
                    className="btn btn--small btn--primary"
                    onClick={toggleLogin}
                >
                    <span className="btn__span text-nowrap">
                        Войти, чтобы записаться
                    </span>
                </Link>
            )}

            {isLoggedIn &&
                is_participate &&
                playerInReserve &&
                isFreePlaceInMainList && (
                    <Button
                        secondary={is_participate}
                        primary={!is_participate}
                        size="small"
                        shadowDesktopDown
                        fullWidth
                        onClick={(e) => onSubscribe(e, true)}
                        disabled={(!is_public && !private_code) || inProgress}
                        mixes={[`shadow-medium-desktop-down`]}
                    >
                        <span className="btn__span">
                            Перейти в основной состав
                        </span>
                    </Button>
                )}

            {showSubscribeOk && (
                <AnimatedModal
                    visible={true}
                    title={`Вы записались на ${
                        is_training ? `тренировку` : `игру`
                    }`}
                    onClose={() => {
                        toggleSubscribeOk();
                        hideWebToAppBanner();
                    }}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {(close) => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {gameType.name}.{" "}
                                {startDT.toFormat("dd.LL.yyyy")} в{" "}
                                {startDT.toLocaleString(Luxon.TIME_24_SIMPLE)}.
                                Организатор -{" "}
                                {`${organizer.family_name} ${organizer.name}`}
                                {is_training &&
                                    trainer &&
                                    `, тренер - ${trainer.family_name} ${trainer.name}`}
                            </p>

                            <Alert visible={true} type="warning">
                                <div className="flex bg-primary-light mb-24-40 pa-20 rounded-15 w-430-tablet-down">
                                    <div className="pa-20">
                                        <Icon type="warning" />
                                    </div>
                                    <div className="flex aic c-gs-medium-em">
                                        {`Отписаться можно до ${canUnsubscribeBefore}`}
                                    </div>
                                </div>
                            </Alert>

                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`, `w-125`]}
                                    onClick={close}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}

            <ConfirmModal
                show={showConfirmModal}
                onSubscribe={onSubscribe}
                setShowConfirmModal={setShowConfirmModal}
            />

            {showSubscribeReserve && (
                <AnimatedModal
                    visible={true}
                    title="Вы попали в резерв"
                    onClose={() => {
                        toggleSubscribeReserve();
                        hideWebToAppBanner();
                    }}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {(close) => (
                        <>
                            <p className="c-gs-medium-em text-justify mb-32">
                                Вы добавлены в резерв. Если освободится место -
                                автоматически в состав вы не попадете, зато
                                получите уведомление о том, что освободилось
                                место
                            </p>

                            <p className="c-gs-medium-em text-justify mb-32">
                                Чтобы оперативно получить уведомление,
                                установите мобильное приложение
                            </p>
                            <div className="mb-32">
                                <MobileAppsLinks />
                            </div>
                            <div className="btn-group-row">
                                <Button
                                    text
                                    size="medium"
                                    onClick={async () => {
                                        await onUnsubscribe();
                                        toggleSubscribeReserve();
                                        hideWebToAppBanner();
                                    }}
                                >
                                    <span className="btn__span">
                                        Отписаться
                                    </span>
                                </Button>
                                <Button primary size="medium" onClick={close}>
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}

            {error && (
                <AnimatedModal
                    visible={true}
                    title={`Внимание!`}
                    onClose={() => setError(null)}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {() => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {error}
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={() => setError(null)}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}

            {showUnsubscribe && (
                <AnimatedModal
                    visible={true}
                    title={`Вы отписались от ${
                        is_training ? `тренировки` : `игры`
                    }`}
                    onClose={onCloseUnsubscribeModal}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {(close) => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {gameType.name}.{" "}
                                {startDT.toFormat("dd.LL.yyyy")} в{" "}
                                {startDT.toLocaleString(Luxon.TIME_24_SIMPLE)}.
                                Организатор -{" "}
                                {`${organizer.family_name} ${organizer.name}`}
                                {is_training &&
                                    trainer &&
                                    `, тренер - ${trainer.family_name} ${trainer.name}`}
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={close}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}

            {error && (
                <AnimatedModal
                    visible={true}
                    title={`Внимание!`}
                    onClose={() => setError(null)}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {() => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {error}
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={() => setError(null)}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}

            {showCantUnsubscribe && (
                <AnimatedModal
                    visible={true}
                    title={`Внимание!`}
                    onClose={toggleCantUnsubscribe}
                    closeOnOverlay={true}
                    modificators={[`small-col`]}
                >
                    {(close) => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                {unsubscribeMessage}
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={close}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}
        </>
    );
};

SignUp.propTypes = {
    ...gameTypes,
    isLoggedIn: PropTypes.bool,
    inProgress: PropTypes.bool,
    closed: PropTypes.bool,
    updateGameData: PropTypes.func,
    userId: PropTypes.number,
    myReserveOrder: PropTypes.number,
    is_participate: PropTypes.bool,
    trackPlayerJoin: PropTypes.func,
    trackPlayerLeft: PropTypes.func,
    dropCard: PropTypes.func,
    gameLink: PropTypes.string,
    gameType: gameTypeTypes,
    players: PropTypes.arrayOf(userTypes),
    max_players: PropTypes.number,
    genderDoesNotMatch: PropTypes.bool,
    userAge: PropTypes.number,
};
export default SignUp;
